const PRIVYR_WEBHOOK_URL =
  'https://www.privyr.com/api/v1/incoming-leads/0vZfjMQw/CUBuShkG';

export async function sendToPrivyr(payload) {
  try {
    const response = await fetch(PRIVYR_WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: payload?.name || '',
        email: payload?.email || '',
        phone: payload?.phone || '',
        message: payload?.message || '',
        source: payload?.source || 'Website Form',
      }),
    });

    if (response.ok) {
      console.log('Privyr notified');
      return true;
    }

    console.warn('Privyr webhook returned:', response.status);
    return false;
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    console.warn('Privyr webhook failed:', message);
    return false;
  }
}
